import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { AgencyPortfolio } from '@/components/agency/portfolio/agency-portfolio';
import {
  portfolioSearchSchema,
  type PortfolioSearch,
} from '@/components/agency/portfolio/portfolio-search';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/')({
  validateSearch: portfolioSearchSchema,
  loader: () => loadNamespaces('agency'),
  staticData: {
    title: 'route.agency_portfolio.title',
  },
  component: AgencyPortfolioRoute,
});

function AgencyPortfolioRoute(): React.ReactElement {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Each change is its own history entry, so Back after a Review returns to this view.
  const onSearchChange = useCallback(
    (patch: Partial<PortfolioSearch>) => {
      void navigate({ search: (current) => ({ ...current, ...patch }) });
    },
    [navigate],
  );
  return <AgencyPortfolio search={search} onSearchChange={onSearchChange} />;
}
